import React from 'react'
import FooterComponent from './components/FooterComponent'
import HeaderComponent from './components/HeaderComponent'
import HomeComponent from './components/HomeComponent'
import AboutComponent from './components/AboutComponent'
import ContactComponent from './components/ContactComponent'
import ServiceComponent from './components/ServiceComponent'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import { BrowserRouter as Router, Route } from 'react-router-dom'
import WorkComponent from './components/WorkComponent'
import ContentComponent from './components/ContentComponent'
import ProductPena from './components/product_component/ProductPena'

function App() {
  return (
    <>
      <Router>
        {/* Header Component */}
        <HeaderComponent />
        {/* ./Header Component */}

        {/* Main Component */}
        <Route exact path="/" render={() => <HomeComponent />} />
        {/* ./Main Component */}

        {/* About Component */}
        <Route path="/about" render={() => <AboutComponent />} />
        {/* ./About Component */}

        {/* Contact Component */}
        <Route path="/contact" render={() => <ContactComponent />} />
        {/* ./Contact Component */}

        {/* Service Component */}
        <Route path="/service" render={() => <ServiceComponent />} />
        {/* ./Service Component */}

        {/* Work Component */}
        <Route path="/work" render={() => <WorkComponent />} />
        {/* ./Work Component */}

        {/* Content Component */}
        <Route path="/content" render={() => <ContentComponent />} />
        {/* ./Content Component */}

        {/* Product Component */}

        {/* Product Pena */}
        <Route path="/productpena" render={() => <ProductPena />} />
        {/* ./Product Pena */}

        {/* ./Product Component */}

        {/* Footer Component */}
        <FooterComponent />
        {/* ./Footer Component */}
      </Router>
    </>
  )
}

export default App
